module.exports = __webpack_public_path__ + "static/img/up-corner-8m-x-2m-inverted_256.3be0f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up-corner-8m-x-2m-inverted_256.png
// module id = 30tj
// module chunks = 0